export default __webpack_public_path__ + "static/media/team5.eb6812f2.jpg";